/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_ForkInputs */

const cs_templates_fork = /** @type {(inputs: Templates_ForkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit kopii`)
};

const en_templates_fork = /** @type {(inputs: Templates_ForkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fork`)
};

/**
* | output |
* | --- |
* | "Fork" |
*
* @param {Templates_ForkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_fork = /** @type {((inputs?: Templates_ForkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_ForkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_fork(inputs)
	return cs_templates_fork(inputs)
});